var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('el-dialog',{attrs:{"title":"Order is locked","visible":_vm.isVisible,"width":"30%"},on:{"update:visible":function($event){_vm.isVisible=$event}}},[_c('p',[_vm._v(_vm._s(_vm.lock.error))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }